import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import AppLayout from "../../components/Layout/AppLayout";
import RewardPrompt from "../../components/Modal/rewardPrompt";
import { useFetchUnratedInteractionQuery } from "../../generated/graphql";
import { RootState, persistor } from "../../store";
import { useIdleTimer } from "react-idle-timer";

import { logoutUser } from "../../features/loggedInUser.features";
import { logoutGuardianUser } from "../../features/guardianUser.features";

import SessionModal from "../../components/Modal/SessionTimeOutModal";

function Dashboard() {
  const dispatch = useDispatch();

  // Reward modal
  const [isOpen, setIsOpen] = useState(false);

  const loggedInUser = useSelector(
    (state: RootState) => state.loggedInUser.data
  );

  const rateNotifierTimer = useSelector(
    // @ts-ignore
    (state: RootState) => state.utils?.rateNotifierTimer as any as Date
  );

  const { data } = useFetchUnratedInteractionQuery({
    variables: { input: { userId: loggedInUser?.id, type: null } },
  });

  const location = useLocation();

  useEffect(() => {
    if (
      data?.fetchUnratedInteraction?.length > 0 &&
      location.pathname !== "/app/account/ratings" &&
      new Date(rateNotifierTimer) < new Date()
    ) {
      setIsOpen(true);
    }
  }, [data?.fetchUnratedInteraction]);

  // Session time out modal
  const [isOpened, setIsOpened] = useState(false);

  // logout function
  function handleLogout() {
    persistor.purge();
    dispatch(logoutGuardianUser());
    dispatch(logoutUser());
  }

  const onPrompt = () => {
    setIsOpened(true);
    console.log("you will be logged out if you dont take an action soon");
  };

  // Log users out after 5 mins of idleness
  const onIdle = () => {
    setIsOpened(false);
    handleLogout();
    console.log("onIdle: user is idle");
  };

  const onActive = (event) => {
    setIsOpened(false);
    console.log("onActive: time remaining");
  };

  const onAction = (event) => {
    setIsOpened(false);
    console.log("onAction: user did something");
  };

  const handleActive = () => {
    setIsOpened(false);
    reset();
  };

  // getRemainingTime before user automatic log out
  const { reset } = useIdleTimer({
    onPrompt,
    onIdle,
    onActive,
    onAction,
    timeout: 1000 * 60 * 10,
    promptTimeout: 1000 * 60 * 1,
    debounce: 0,
  });

  return (
    <>
      <AppLayout />
      <RewardPrompt
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        data={data?.fetchUnratedInteraction[0]}
      />
      <SessionModal isOpened={isOpened} handleActive={handleActive} />
    </>
  );
}

export default Dashboard;
